export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";